import { gql } from '@apollo/client';

export default gql`
  mutation postDripEvent($input: PostDripEventInput!) {
    postDripEvent(input: $input)
  }
`;
